import { AutoComplete } from "primereact/autocomplete";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const UserAutoCompleteInput = (props) => {

    const { selfAssign, currentUser, placeholderTxt = "Search for user", allowMultiple = false } = props;
    const userOptions = useSelector((state) => state.common.userList);
    const [suggestions, setSuggestions] = useState([]);
    const [selectedItems, setSelectedItems] = useState(currentUser || []);
    const [allowMultiUser, setAllowMultiUser] = useState(false);

    useEffect(() => {
        setSelectedItems(currentUser);
    }, [selfAssign, currentUser]);

    useEffect(() => {
        setAllowMultiUser(allowMultiple);
    }, [allowMultiple]);

    const fetchSuggestions = (event) => {
        const query = event.query.toLowerCase();
        // Filter user options based on the input query
        const filteredSuggestions = userOptions.filter(user => 
            user?.label?.toLowerCase().includes(query) // Adjust property based on user object structure
        );
        setSuggestions(filteredSuggestions);
    };
    
    const onUserSelect = (e) => {
        setSelectedItems(e.value);
        props.handleSearchUser(e.value);
    };

    return (
        <div className="w-full">
            { allowMultiUser && <AutoComplete
                    forceSelection
                    multiple
                    value={selectedItems}
                    suggestions={suggestions}
                    completeMethod={fetchSuggestions}
                    field="label"
                    placeholder={placeholderTxt}
                    onChange={onUserSelect}
                />
            }
            { !allowMultiple && <AutoComplete
                    forceSelection 
                    value={selectedItems}
                    suggestions={suggestions}
                    completeMethod={fetchSuggestions}
                    field="label"
                    placeholder={placeholderTxt}
                    onSelect={onUserSelect}
                />
            }
        </div>
    );
};

export default UserAutoCompleteInput;
